import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { PartnerService } from 'src/app/core/services/partner.service';
import { CustomButtonDto } from 'src/app/shared/components/app-button/app-button-dto';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { CarouselItem } from 'src/app/shared/components/carousel-plans/carousel-plans.model';
import { LayoutConfigService } from 'src/app/shared/services/layout-config.service';

@Component({
  selector: 'app-section-carousel-beneficios-ceara',
  standalone: true,
  imports: [CommonModule, AppButtonComponent, RouterLink],
  templateUrl: './section-carousel-beneficios-ceara.component.html',
  styleUrl: './section-carousel-beneficios-ceara.component.scss'
})
export class SectionCarouselBeneficiosCearaComponent  implements OnInit{
@ViewChild('carouselContainer') carouselContainer!: ElementRef;

  styles: any;
  public classes: any;
  chunkedItems: CarouselItem[][] = [];
  chunkSize = 4;
  isMobile = false;
  showIndicators = false;
  layoutVersion = this.layoutConfigService.getLayoutVersion();
  title = '';
  subTitle = '';
  showSubtitle = false;
  image :any;

  items: CarouselItem[] = [];

  buttonPartnerOptions: CustomButtonDto = {
    primaryColor: '#3b0058',
    secondaryColor: '#3b0058',
    buttonText: 'QUERO SER SÓCIO',
    buttonTextColor: '#ffffff',
    borderRadius: '1.5rem',
    buttonBorderWidth: 'none',
    buttonBorderColor: 'none',
    buttonSize: 'btn btn-md px-4 py-2',
    fontSize: 16
  };

  constructor(
    private layoutConfigService: LayoutConfigService,
    private partnerService: PartnerService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.setCardSize(window.innerWidth);
    this.getAllPartners();
    this.getParnersStyles();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const width = (event.target as Window).innerWidth;
    this.isMobile = width < 992;
    if(this.isMobile){
      this.styles['--background-image'] = `url('/assets/imagens/IMAGEM BENEFICIOS EXCLUSIVOS MOBILE.png')`;
    } else {
      this.styles['--background-image'] = `url(${this.commonService.getImageStr(this.image?.id)})` || 'none';
    }
  }

  getAllPartners() {
    this.partnerService.getAllPartners().subscribe((partners: any) => {
      this.items = partners.content.map((partner: any) => ({
        title: partner.partnerName,
        conteudo: partner.description.replace(/\n/g, "<br />"),
        descricao: partner.planName,
        src: this.commonService.getImageStr(partner.document?.id),
        discount: this.formatDiscount(partner.isPercentualDiscount, partner.discount),
        link: partner.link
      }));
    });
  }

  private formatDiscount(isPercentual: boolean, discount: number | null): string {
    if (discount == null || discount === 0) {
      return '0';
    }
    return isPercentual
      ? `${discount}%`
      : `R$ ${discount.toFixed(2).replace('.', ',')}`;
  }

  setCardSize(innerWidth: number) {
    this.isMobile = innerWidth < 768;
  }

  scrollCarousel(direction: 'prev' | 'next'): void {
    const container = this.carouselContainer.nativeElement;
    const items = container.querySelectorAll('.benefit-card-container');

    if (items.length < 2) return;

    const scrollAmount = items[1].offsetLeft - items[0].offsetLeft;

    if (direction === 'prev') {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  }

  getParnersStyles() {
    this.partnerService.getParnersStyles().subscribe((styles: any) => {
      let partnerStylesResponse = styles;
      this.image = partnerStylesResponse?.document;
      this.styles = {
        '--section-title-font-size': this.commonService.getRemFontSize(partnerStylesResponse?.sectionTitleFontSize, this.isMobile),
        '--section-title-color': partnerStylesResponse?.sectionTitleColor || '#ffffff',
        '--background-color': partnerStylesResponse?.backgroundColor || '#3b0058',
        '--background-image': this.isMobile ? `url('/assets/imagens/IMAGEM BENEFICIOS EXCLUSIVOS MOBILE.png')` : partnerStylesResponse?.backgroundIsImage ? `url(${this.commonService.getImageStr(partnerStylesResponse?.document?.id)})` : 'none',
      }
      this.title = partnerStylesResponse?.sectionTitle || 'BENEFÍCIOS EXCLUSIVOS';
    });
  }

  openLink(parceiro: any): void {
    if (parceiro.link) {
      window.open(parceiro.link, '_blank');
    }
  }
}
